/**
 * Die Jahreszeit der Tagesszene. (07.10.2026)
 *
 * Martin zum neuen Entwurf: *„Bitte gleich in der Entwicklung auch noch den
 * Herbst, den Winter und den Frühling mit einbauen, sodass wir dann wechseln
 * können, je nach Jahreszeit."*
 *
 * Zwei Wege, eine Antwort:
 *   - AUTOMATISCH nach dem Kalender, meteorologisch (Nordhalbkugel):
 *     Frühling März–Mai, Sommer Juni–August, Herbst September–November,
 *     Winter Dezember–Februar. Der Tag ist der WIENER Tag — dieselbe Regel
 *     wie bei der Tageszeit (tagesszene.ts, wienerMinute): um 00:30 am
 *     1. März in Wien ist Frühling, auch wenn das Gerät in New York steht.
 *   - die Einstellung `szeneJahreszeit` schlägt den Kalender, solange sie
 *     nicht „auto" ist.
 *
 * ⚠️ Steht in shared/, weil Server (Prüfung der Einstellung) und Oberfläche
 *    (Szene, Einstellungsseite) dieselbe Liste brauchen. Zwei Listen laufen
 *    auseinander — und dann streicht der Server einen Wert, den die Seite
 *    anbietet.
 */

export const JAHRESZEITEN = ["fruehling", "sommer", "herbst", "winter"] as const;
export type Jahreszeit = (typeof JAHRESZEITEN)[number];

/** Was man einstellen kann: automatisch oder eine feste Jahreszeit. */
export const JAHRESZEIT_WAHLEN = ["auto", ...JAHRESZEITEN] as const;
export type JahreszeitWahl = (typeof JAHRESZEIT_WAHLEN)[number];

/** Die Vorgabe: nach dem Kalender. */
export const JAHRESZEIT_VORGABE: JahreszeitWahl = "auto";

export const JAHRESZEIT_NAME: Record<Jahreszeit, string> = {
  fruehling: "Frühling",
  sommer: "Sommer",
  herbst: "Herbst",
  winter: "Winter",
};

export function istJahreszeitWahl(v: unknown): v is JahreszeitWahl {
  return typeof v === "string" && (JAHRESZEIT_WAHLEN as readonly string[]).includes(v);
}

/** Der Monat (1–12) in Wien — nicht der des Geräts und nicht UTC. */
export function wienerMonat(d: Date): number {
  const teil = new Intl.DateTimeFormat("en-GB", { timeZone: "Europe/Vienna", month: "numeric" })
    .formatToParts(d)
    .find((t) => t.type === "month");
  return Number(teil?.value ?? d.getMonth() + 1);
}

/** Meteorologische Jahreszeit am Wiener Datum. */
export function jahreszeitAmDatum(d: Date): Jahreszeit {
  const m = wienerMonat(d);
  if (m >= 3 && m <= 5) return "fruehling";
  if (m >= 6 && m <= 8) return "sommer";
  if (m >= 9 && m <= 11) return "herbst";
  return "winter";
}

/**
 * Welche Jahreszeit die Szene zeigt: die eingestellte, sonst der Kalender.
 * Ein unbekannter Wert (alter Stand, Tippfehler) gilt als „auto".
 */
export function jahreszeitFuer(wahl: unknown, d: Date): Jahreszeit {
  if (istJahreszeitWahl(wahl) && wahl !== "auto") return wahl;
  return jahreszeitAmDatum(d);
}
